import { createEffect, createSignal } from "solid-js";
import { defaultQuestionEffort, type QuestionEffort } from "./questionEfforts";

/** An effort upgrade the viewer accepted for an answer in the conversation. */
export type AcceptedEffortUpgrade = {
	requestId: string;
	effort: QuestionEffort;
};

/**
 * The effort a follow-up box asks at. Follow-ups carry on at an accepted
 * upgrade's effort, but only one the viewer picks themselves becomes their
 * default, so pass `rememberEffort` to the box.
 */
export function useUpgradableEffort(
	acceptedUpgrade: () => AcceptedEffortUpgrade | undefined,
) {
	const [effort, setEffort] = createSignal<QuestionEffort>(
		defaultQuestionEffort(),
	);
	const [fromUpgrade, setFromUpgrade] = createSignal(false);
	let appliedRequestId: string | undefined;
	createEffect(() => {
		const upgrade = acceptedUpgrade();
		if (!upgrade || upgrade.requestId === appliedRequestId) {
			return;
		}
		appliedRequestId = upgrade.requestId;
		setEffort(upgrade.effort);
		setFromUpgrade(true);
	});

	return {
		effort,
		chooseEffort: (chosen: QuestionEffort) => {
			setEffort(chosen);
			setFromUpgrade(false);
		},
		rememberEffort: () => !fromUpgrade(),
	};
}
